export default {
    setGiftee (state, { payload }) {
        state.giftee = payload
    },
    setSelectedGiftId (state, giftId) {
        state.selectedGiftId = giftId
    },
    setCorporateClientPlanId (state, planId) {
        state.corporateClientPlanId = planId
    },
    setCorporateClients (state, {clients}) {
        state.corporateClients = clients
    },
    setCorporateClient (state, {client}) {
        state.corporateClient = client
    },
    setSwitchCorporateClient (state, {client}) {
        state.SwitchCorporateClient = client
    },
    setCorporateClientForDemo (state, {client}) {
        state.corporateClientForDemo = client
    },
    setGiftingError (state, { error }) {
        state.giftingError = error
    },
    setCorpHeaderColor (state, color) {
        state.corpHeaderColor = color
    },
    setCorpFooterColor (state, color) {
        state.corpFooterColor = color
    },
    setCorpButtonColor (state, color) {
        state.corpButtonColor = color
    },
    setCorpHeadingColor (state, color) {
        state.corpHeadingColor = color
    },
    setParentCorporation (state, {parentCorp}) {
        state.parentCorporation = parentCorp
    },
    setCorpRestrictedRegions (state, {payload}) {
        state.corpRestrictedRegions = payload
    },
    setCorporationRegions (state, {payload}) {
        state.corporationRegions = payload
    },
    setCorporateGiftInfo (state, {gift}) {
        if (gift) {
            state.corporateGiftInfo = gift
            if (localStorage.getItem('corporateGiftInfoObject')) {
                localStorage.removeItem('corporateGiftInfoObject')
                localStorage.setItem('corporateGiftInfoObject', JSON.stringify(gift))
            } else {
                localStorage.setItem('corporateGiftInfoObject', JSON.stringify(gift))
            }
        } else {
            if (localStorage.getItem('corporateGiftInfoObject')) {
                localStorage.removeItem('corporateGiftInfoObject')
            } else {
                localStorage.setItem('corporateGiftInfoObject', JSON.stringify(gift))
            }
            state.corporateGiftInfo = null
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/gifts/mutations.js